import { useState, type ButtonHTMLAttributes, type MouseEvent } from "react";
import WaitlistDialog from "./WaitlistDialog";
import type { WaitlistAppearance } from "./WaitlistForm";

/**
 * Drop-in replacement for Typeform's <PopupButton id="…">: same className /
 * style / onClick / onMouseEnter surface, minus `id`. Owns its own open state
 * and mounts the dialog only while open, so the prerender pass emits a bare
 * <button> and no provider is needed in App.tsx or entry-prerender.tsx.
 */
type WaitlistButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  /** Dialog look: "marketing" on the public marketing site. */
  appearance?: WaitlistAppearance;
};

const WaitlistButton = ({ onClick, children, appearance = "default", ...rest }: WaitlistButtonProps) => {
  const [open, setOpen] = useState(false);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    onClick?.(event);
    setOpen(true);
  };

  return (
    <>
      <button type="button" {...rest} onClick={handleClick}>
        {children}
      </button>
      {open && <WaitlistDialog open={open} onOpenChange={setOpen} appearance={appearance} />}
    </>
  );
};

export default WaitlistButton;
